// extracted by mini-css-extract-plugin
module.exports =  {"section":"_32bbee5fda--section--UpyCR","list":"_32bbee5fda--list--zOiDE","column":"_32bbee5fda--column--JLwFl"};